// src/utils/vat.js

export const DEFAULT_VAT_RATES = {
  DE: 19,
  AT: 20,
  FR: 20,
  CZ: 21,
  DK: 25,
  ES: 21,
  IT: 22,
  NL: 21,
  BE: 21,
  CH: 7.7,
  LU: 17,
  SE: 25,
  NO: 25,
  FI: 24,
  PL: 23,
};

const NAME_TO_CODE = {
  germany: 'DE',
  deutschland: 'DE',
  austria: 'AT',
  österreich: 'AT',
  france: 'FR',
  frankreich: 'FR',
  spain: 'ES',
  españa: 'ES',
  italy: 'IT',
  italia: 'IT',
  netherlands: 'NL',
  nederland: 'NL',
  belgium: 'BE',
  belgië: 'BE',
  luxembourg: 'LU',
  denmark: 'DK',
  dänemark: 'DK',
  sweden: 'SE',
  sverige: 'SE',
  norway: 'NO',
  poland: 'PL',
  polska: 'PL',
  switzerland: 'CH',
  schweiz: 'CH',
  suisse: 'CH',
  czechrepublic: 'CZ',
  czech: 'CZ',
  'czech republic': 'CZ',
  finland: 'FI',
};

const hasValue = (v) => v !== undefined && v !== null && v !== '';

export function guessVatRate(marketLike) {
  if (!marketLike) return null;
  let code = null;
  if (typeof marketLike === 'string') {
    code = marketLike;
  } else if (typeof marketLike === 'object') {
    const direct = marketLike.vat_rate ?? marketLike.default_vat_rate;
    if (hasValue(direct)) {
      const parsed = Number(direct);
      if (!Number.isNaN(parsed)) return parsed;
    }
    code = marketLike.iso || marketLike.country_code || marketLike.code || marketLike.market_code || marketLike.label || marketLike.name;
  }
  if (!hasValue(code)) return null;
  const normalized = String(code).trim();
  if (!normalized) return null;
  const upper = normalized.toUpperCase();
  if (hasValue(DEFAULT_VAT_RATES[upper])) {
    return DEFAULT_VAT_RATES[upper];
  }
  const mapped = NAME_TO_CODE[normalized.toLowerCase()];
  if (mapped && hasValue(DEFAULT_VAT_RATES[mapped])) {
    return DEFAULT_VAT_RATES[mapped];
  }
  return null;
}

export function coerceVatInput(value) {
  if (!hasValue(value)) return null;
  const num = Number(value);
  if (!Number.isFinite(num) || num < 0) return null;
  return num;
}
